import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  color: white;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;

  h1, h2 {
    color: #FFD700;
    margin: 1.5em 0 1em;
  }

  h1 {
    font-size: 2.5em;
    margin-top: 0;
  }

  h2 {
    font-size: 1.8em;
  }

  p {
    margin: 1em 0;
  }

  a {
    color: #FFD700;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  ul, ol {
    margin: 1em 0;
    padding-left: 2em;
  }

  hr {
    border: none;
    border-top: 1px solid #333;
    margin: 2em 0;
  }
`;

const Privacy = () => {
  return (
    <Container>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> December 27, 2024</p>

      <p>Welcome to BusyBee (the "App"), a service provided by Little Apps Ltd ("we," "us," or "our"). We respect your privacy and are committed to explaining how we handle your information. This Privacy Policy covers how we collect, use, and protect the data generated when you use BusyBee.</p>

      <h2>1. Scope of This Policy</h2>
      <p>This Privacy Policy applies to all users of BusyBee worldwide. It describes the information we collect (if any), how we use it, and under what circumstances we share it when you use:</p>
      <ul>
        <li>The BusyBee mobile application.</li>
        <li>Any related website or services provided by Little Apps Ltd.</li>
      </ul>

      <h2>2. What Information We Collect</h2>
      <h3>2.1 Personal Information</h3>
      <ul>
        <li><strong>We do not require user registration</strong> nor do we collect personal data such as names, email addresses, or phone numbers.</li>
        <li><strong>We do not collect any sensitive personal information</strong> (e.g., location data, health data, financial information).</li>
      </ul>

      <h3>2.2 Analytics Data</h3>
      <p>We may collect certain technical information automatically to help us understand how you use BusyBee and improve the App. This may include:</p>
      <ul>
        <li><strong>Device identifiers</strong> (e.g., device ID, operating system, and hardware information).</li>
        <li><strong>Crash and performance logs</strong> if the App experiences an error.</li>
      </ul>

      <h2>3. How We Use the Information</h2>
      <p>Since we do not collect personal data, our usage of information is limited to the technical or device data referenced above. Specifically, we use analytics data to:</p>
      <ol>
        <li><strong>Maintain and Improve the App</strong>
          <ul>
            <li>Diagnose crashes or performance issues.</li>
            <li>Understand general usage trends.</li>
          </ul>
        </li>
        <li><strong>Enhance User Experience</strong>
          <ul>
            <li>Identify and fix bugs or errors.</li>
            <li>Optimize the user interface and features.</li>
          </ul>
        </li>
      </ol>

      <h2>4. Contact Us</h2>
      <p>If you have any questions, concerns, or feedback about this Privacy Policy or BusyBee's data practices, please contact us at:</p>
      <p>
        Little Apps Ltd<br />
        71-75 Shelton Street<br />
        Covent Garden, London<br />
        United Kingdom, WC2H 9JQ<br />
        Email: <a href="mailto:busybeehelp@littleapps.xyz">busybeehelp@littleapps.xyz</a>
      </p>

      <hr />
      <p><strong>Last Updated:</strong> December 27, 2024</p>
    </Container>
  );
};

export default Privacy; 